import ReplyIcon from "@mui/icons-material/Reply";
import { Button, CircularProgress } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { setMapType } from "~/redux/reducers/mapReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";

const useStyles = makeStyles((theme) => ({
  button: {
    position: "absolute",
    bottom: theme.spacing(3),
    left: theme.spacing(10),
    zIndex: theme.zIndex.speedDial,
  },
  icon: {
    transform: "scaleX(-1)",
  },
}));

const CesiumMapButton = (): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation("map");
  const dispatch = useAppDispatch();
  const cesiumState = useAppSelector((s) => s.map.cesiumState);

  return (
    <Button
      color="primary"
      variant="contained"
      className={classes.button}
      classes={{ endIcon: classes.icon }}
      endIcon={
        cesiumState === "loading" ? (
          <CircularProgress size={18} color="secondary" />
        ) : (
          <ReplyIcon />
        )
      }
      onClick={() => {
        dispatch(setMapType("3d"));
      }}
    >
      {t("switch-to-3d")}
    </Button>
  );
};

export default CesiumMapButton;
